<div class="products-container">
	<div *ngFor="let product of products" class="product border-gradient green">
		<gob-product-card [product]="product"></gob-product-card>
	</div>
</div>
